export const CLEAR_ERRORS_CUSTOMERS_COMMENT = 'CLEAR_ERRORS_CUSTOMERS_COMMENT';
